import { Decimal } from 'decimal.js';

/**
 * Tax inside a tax-inclusive invoice line, at `rate` as a fraction (0.1 for 10%).
 *
 * The one rounding every inclusive invoice line and every figure that promises an invoice's tax
 * (a quote's prepayment) must share. The float divide before Decimal is deliberate legacy: stored
 * invoices were taxed this way, and a "more exact" Decimal divide moves half-cent cases by a cent.
 */
export function inclusiveLineTax(lineSubTotal: number, rate: number): number {

    return new Decimal((lineSubTotal / (1 + rate)) * rate).toDP(2).toNumber();
}
